import './assets/index32.css';var P = Object.defineProperty, z = Object.defineProperties;
var F = Object.getOwnPropertyDescriptors;
var g = Object.getOwnPropertySymbols;
var _ = Object.prototype.hasOwnProperty, x = Object.prototype.propertyIsEnumerable;
var y = (o, e, a) => e in o ? P(o, e, { enumerable: !0, configurable: !0, writable: !0, value: a }) : o[e] = a, r = (o, e) => {
  for (var a in e || (e = {}))
    _.call(e, a) && y(o, a, e[a]);
  if (g)
    for (var a of g(e))
      x.call(e, a) && y(o, a, e[a]);
  return o;
}, d = (o, e) => z(o, F(e));
var f = (o, e) => {
  var a = {};
  for (var s in o)
    _.call(o, s) && e.indexOf(s) < 0 && (a[s] = o[s]);
  if (o != null && g)
    for (var s of g(o))
      e.indexOf(s) < 0 && x.call(o, s) && (a[s] = o[s]);
  return a;
};
import { jsxs as I, jsx as m } from "react/jsx-runtime";
import { forwardRef as T } from "react";
import { b as U, B as V, f as W, c as X } from "./factory-BnRIVbT0.js";
import { e as Z, c as h } from "./get-size-BzhHC8s2.js";
import { u as $, c as q } from "./use-styles-BXCSW-9F.js";
import { p as A } from "./polymorphic-factory-CU4yDpSd.js";
var C = { root: "m_347db0ec", "root--dot": "m_fbd81e3d", label: "m_5add502a", section: "m_91fdda9b" };
const D = {}, E = q(
  (o, { radius: e, color: a, gradient: s, variant: t, size: i, autoContrast: l }) => {
    const c = o.variantColorResolver({
      color: a || o.primaryColor,
      theme: o,
      gradient: s,
      variant: t || "filled",
      autoContrast: l
    });
    return {
      root: {
        "--badge-height": h(i, "badge-height"),
        "--badge-padding-x": h(i, "badge-padding-x"),
        "--badge-fz": h(i, "badge-fz"),
        "--badge-radius": e === void 0 ? void 0 : Z(e),
        "--badge-bg": a || t ? c.background : void 0,
        "--badge-color": a || t ? c.color : void 0,
        "--badge-bd": a || t ? c.border : void 0,
        "--badge-dot-color": t === "dot" ? W(a, o) : void 0
      }
    };
  }
), u = A((o, e) => {
  const a = U("Badge", D, o), B = a, {
    classNames: s,
    className: t,
    style: i,
    styles: l,
    unstyled: c,
    vars: N,
    radius: K,
    color: L,
    gradient: M,
    leftSection: p,
    rightSection: b,
    children: R,
    variant: v,
    fullWidth: S,
    autoContrast: O,
    circle: w,
    mod: j
  } = B, k = f(B, [
    "classNames",
    "className",
    "style",
    "styles",
    "unstyled",
    "vars",
    "radius",
    "color",
    "gradient",
    "leftSection",
    "rightSection",
    "children",
    "variant",
    "fullWidth",
    "autoContrast",
    "circle",
    "mod"
  ]), n = $({
    name: "Badge",
    props: a,
    classes: C,
    className: t,
    style: i,
    classNames: s,
    styles: l,
    unstyled: c,
    vars: N,
    varsResolver: E
  });
  return /* @__PURE__ */ I(
    V,
    d(r(d(r({
      variant: v,
      mod: [
        {
          block: S,
          circle: w,
          "with-right-section": !!b,
          "with-left-section": !!p
        },
        j
      ]
    }, n("root", { variant: v })), {
      ref: e
    }), k), {
      children: [
        p && /* @__PURE__ */ m("span", d(r({}, n("section")), { "data-position": "left", children: p })),
        /* @__PURE__ */ m("span", d(r({}, n("label")), { children: R })),
        b && /* @__PURE__ */ m("span", d(r({}, n("section")), { "data-position": "right", children: b }))
      ]
    })
  );
});
u.classes = C;
u.displayName = "@mantine/core/Badge";
const G = "Badge-module__root___IZCUX", H = {
  root: G
}, J = T((i, t) => {
  var l = i, {
    children: o,
    variant: e = "light",
    className: a
  } = l, s = f(l, [
    "children",
    "variant",
    "className"
  ]);
  return /* @__PURE__ */ m(
    u,
    d(r({
      ref: t,
      "data-variant": e,
      className: X(H.root, a)
    }, s), {
      children: o
    })
  );
});
J.displayName = "Badge";
export {
  J as B,
  H as a
};
